<template>
    <div>
      <div
        class="language-container add--margin-top"
        v-show="canDisplayDefault"
      >
        <a
          class="language-container__anchor"
          v-for="(languageType, key) in languageTypes"
          :key="key"
          @click="() => onChange(key)"
        >
          <div
            class="language-container__anchor__button"
            :class="{
              'language-active': localLanguageTypesIndex === key,
            }"
          >
            <h3 class="h5">{{ languageType.foreignName }}</h3>
          </div>
        </a>
      </div>

      <div class="input-dropdown" v-if="canDisplayAdaptive">
          <label>Language</label>
          <select @change="({ target: { value }}) => onChange(value)">
              <option
                  v-for="({countryCode, foreignName }, index) in languageTypes"
                  :key="index"
                  :value="index"
                  :selected="index === localLanguageTypesIndex"
              >
                  {{ `${countryCode} - ${foreignName}`}}
              </option>
          </select>
      </div>
    </div>
</template>

<script>
const CONSTANTS = {
  MIN_LANGUAGES_TO_DISPLAY_ADAPTIVE: 3
};

export default {
  props: {
    localLanguageTypesIndex: Number,
    languageTypes: Array,
    minLanguagesToDisplay: Number
  },
  computed: {
    canDisplayDefault() {
      if (!this.languageTypes || !this.languageTypes.length) {
        return false;
      }

      return this.languageTypes.length > 1
        && this.languageTypes.length < (this.minLanguagesToDisplay || CONSTANTS.MIN_LANGUAGES_TO_DISPLAY_ADAPTIVE);
    },
    canDisplayAdaptive() {
      if (!this.languageTypes || !this.languageTypes.length) {
        return false;
      }

      return this.languageTypes.length >= (this.minLanguagesToDisplay || CONSTANTS.MIN_LANGUAGES_TO_DISPLAY_ADAPTIVE);
    }
  },
  methods: {
    onChange(value) {
      this.$emit('change', Number(value));
    }
  }
}
</script>